"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationRendererEntry = void 0;
var csod = require("player-core");
var React = require("react");
var DropdownList_1 = require("../DropdownList/DropdownList");
var checkbox_1 = require("@csod/checkbox");
var FieldDateRange_1 = require("../FieldDateRange/FieldDateRange");
var DatePicker_1 = require("../DatePicker/DatePicker");
var textbox_1 = require("@csod/textbox");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
var GridCol_1 = require("player-layout-controls/controls/GridCol");
var Panel_1 = require("player-layout-controls/controls/Panel");
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink/Hyperlink");
var Divider_1 = require("player-common-controls/controls/Divider/Divider");
var Text_1 = require("player-common-controls/controls/Text/Text");
require("./ApplicationRendererEntry.css");
var ApplicationRendererEntry = (function (_super) {
    __extends(ApplicationRendererEntry, _super);
    function ApplicationRendererEntry(props) {
        var _this = _super.call(this, props) || this;
        _this.getFieldHtml = function (field, fi, eix) {
            var html;
            var textLength;
            switch (field.fieldData.fieldTypeString) {
                case 'shortTextBox':
                    textLength = csod.viewModel.isIncreaseCharacterLengthForResumeFields ? 200 : 100;
                    html = _this.buildTextBox(field, fi, eix, textLength, true, "Text", false);
                    break;
                case 'scrollingTextBox':
                    textLength = csod.viewModel.isIncreaseCharacterLengthForResumeFields ? 8000 : 3500;
                    html = _this.buildTextBox(field, fi, eix, textLength, true, "Text", true);
                    break;
                case 'dropdown':
                    html = _this.buildDropdown(field, fi, eix, "Block");
                    break;
                case 'numericField':
                    html = _this.buildTextBox(field, fi, eix, 15, true, "Text", false);
                    break;
                case "dateField":
                    html = _this.buildDateField(field, fi, field.fieldData.displayFullDate ? "Short" : "MonthOnlyShort");
                    break;
                case 'checkbox':
                    html = _this.buildCheckbox(field, fi, eix, true, true);
                    break;
                case 'attributeList':
                    html = _this.buildDropdown(field, fi, eix, "Block");
                    break;
                case 'dateRangeField':
                    html = _this.buildDateRange(field, fi);
                    break;
            }
            return React.createElement(GridCol_1.GridCol, { width: "12", widthForSm: field.fieldData.width, key: _this.props.addEntryText + "_" + field.fieldData.fieldTypeString + "_" + fi }, html);
        };
        _this.buildApplicationRendererFields = function () {
            return _this.state.entries.map(function (entry, h) {
                return (React.createElement("div", { key: _this.props.addEntryText + "_" + h },
                    React.createElement(GridLayout_1.GridLayout, { gutterHorizontal: "Medium", gutterVertical: "Small" }, entry.values.map(function (field, i) { return _this.getFieldHtml(field, i, h); })),
                    !entry.hideDelete ? (React.createElement(Panel_1.Panel, { horizontalAlign: "Right", paddingTop: "Medium" },
                        React.createElement(Hyperlink_1.Hyperlink, { role: 'button', type: "Action", onClick: function () { _this._onEntryDeleted(_this.props.sectionId, entry, h); } },
                            React.createElement(Text_1.Text, { text: _this.props.deleteEntryText, color: "Error", weight: "SemiBold" })))) : null,
                    React.createElement(Divider_1.Divider, { color: "Grey50", marginTop: "Xlarge", marginBottom: "Xlarge" })));
            });
        };
        _this.state = {
            entries: props.entries
        };
        _this._onChange = _this._onChange.bind(_this);
        _this._onChangeNoId = _this._onChangeNoId.bind(_this);
        _this._onEntryDeleted = _this._onEntryDeleted.bind(_this);
        _this._onAddEntry = _this._onAddEntry.bind(_this);
        _this._onChangeDate = _this._onChangeDate.bind(_this);
        _this._onChangeDateRange = _this._onChangeDateRange.bind(_this);
        _this.newEntryAdded = false;
        _this.requiredDateErrorMessage = csod.locales.get('ATS.Player.ResponsiveApplication.ResumeAction.RequiredDateRangeError', 'Start Date/End Date is required');
        return _this;
    }
    ApplicationRendererEntry.prototype.componentDidUpdate = function () {
        if (this.focusRef && this.newEntryAdded && (this.focusRef.id != (this.lastFocusRef ? this.lastFocusRef.id : ""))) {
            this.focusRef.focus();
            this.lastFocusRef = this.focusRef;
        }
    };
    ApplicationRendererEntry.prototype.componentWillReceiveProps = function (nextProps) {
        var entries = nextProps.entries, minimumEntries = nextProps.minimumEntries;
        if (minimumEntries > 0 && entries.length < minimumEntries) {
            var additionalEntries = minimumEntries - entries.length;
            for (var i = 0; i < additionalEntries; i++) {
                this.props.onAddEntry(this.props.sectionId);
            }
        }
        entries.slice(0, minimumEntries).forEach(function (e) { return e.hideDelete = true; });
        if (entries.length)
            this.setState({ entries: entries });
    };
    ApplicationRendererEntry.prototype.toggleNewEntryFlag = function (flagValue) {
        this.newEntryAdded = flagValue;
    };
    ApplicationRendererEntry.prototype._onAddEntry = function (sectionId) {
        this.toggleNewEntryFlag(true);
        this.props.onAddEntry && this.props.onAddEntry(sectionId);
        this.setState({ entries: this.props.entries });
    };
    ApplicationRendererEntry.prototype._onEntryDeleted = function (sectionId, entry, entryIndex) {
        this.toggleNewEntryFlag(false);
        if (this.lastFocusRef && this.focusRef && this.lastFocusRef.id === this.focusRef.id) {
            this.lastFocusRef = undefined;
        }
        this.props.onEntryDeleted && this.props.onEntryDeleted(sectionId, entry, entryIndex);
    };
    ApplicationRendererEntry.prototype._onChange = function (val, fieldIndexId, entryIndexId) {
        this.toggleNewEntryFlag(false);
        var entries = this.state.entries;
        entries[entryIndexId].values[fieldIndexId].value1 = val;
        var fieldId = entries[entryIndexId].values[fieldIndexId].fieldData.idTag;
        this.setState({ entries: entries });
        this.props.onChange && this.props.onChange(val, fieldId);
    };
    ApplicationRendererEntry.prototype._onChangeNoId = function (val, fieldIndexId, entryIndexId) {
        this.toggleNewEntryFlag(false);
        var entries = this.state.entries;
        entries[entryIndexId].values[fieldIndexId].value1 = val;
        var field = entries[entryIndexId].values[fieldIndexId];
        this.setState({ entries: entries });
        this.props.onChange && this.props.onChangeNoId(val, field);
    };
    ApplicationRendererEntry.prototype._onChangeDate = function (date, value, isValid, id) {
        this.toggleNewEntryFlag(false);
        this.props.onChangeDate && this.props.onChangeDate(date, value, isValid, id);
    };
    ApplicationRendererEntry.prototype._onChangeDateRange = function (date, value, isValid, id) {
        this.toggleNewEntryFlag(false);
        this.props.onChangeDaterange && this.props.onChangeDaterange(date, value, isValid, id);
    };
    ApplicationRendererEntry.prototype.buildTextBox = function (field, fi, eix, length, showLabel, type, scrollable) {
        var _this = this;
        return (React.createElement(textbox_1.Textbox, { label: field.fieldData.title, isRequired: field.fieldData.isRequired, showLabel: showLabel, value: field.value1, id: field.fieldData.idTag, tag: field.fieldData.idTag, type: type, maxLength: length, errorMessage: field.errorMessage, onChange: function (val) { _this._onChange(val, fi, eix); }, onRef: fi === 0 ? function (r) { return _this.focusRef = r; } : function () { }, key: field.fieldData.fieldTypeString + "_" + fi, scrollable: scrollable }));
    };
    ApplicationRendererEntry.prototype.buildDropdown = function (field, fi, eix, width) {
        var _this = this;
        return (React.createElement(DropdownList_1.DropdownList, { label: field.fieldData.title, items: field.fieldData.items, width: width, value: field.value1, id: field.fieldData.idTag, tag: field.fieldData.idTag, isRequired: field.fieldData.isRequired, errorMessage: field.errorMessage, onChange: function (val) { _this._onChangeNoId(val, fi, eix); }, onRef: fi === 0 ? function (r) { return _this.focusRef = r; } : function () { }, key: field.fieldData.fieldTypeString + "_" + fi }));
    };
    ApplicationRendererEntry.prototype.buildDateField = function (field, fi, format) {
        var _this = this;
        return (React.createElement(DatePicker_1.DatePicker, { label: field.fieldData.title, isRequired: field.fieldData.isRequired, format: format, value: field.value1, tag: field.fieldData.idTag, id: field.fieldData.idTag, errorMessage: field.errorMessage, onChange: function (date, value, isValid, id) { _this._onChangeDate(date, value, isValid, id); }, onRef: fi === 0 ? function (r) { return _this.focusRef = r; } : function () { }, key: field.fieldData.fieldTypeString + "_" + fi, shouldClearIfNotValid: true, showMonthYearPicker: true, isMonthPicker: !(field.fieldData.displayFullDate) }));
    };
    ApplicationRendererEntry.prototype.buildCheckbox = function (field, fi, eix, enabled, showLabel) {
        var _this = this;
        return (React.createElement(checkbox_1.Checkbox, { isEnabled: enabled, showLabel: showLabel, label: field.fieldData.title, isChecked: field.value1, id: field.fieldData.idTag, errorMessage: field.errorMessage, tag: field.fieldData.idTag, onChange: function (val) { _this._onChange(val, fi, eix); }, onRef: fi === 0 ? function (r) { return _this.focusRef = r; } : function () { }, key: field.fieldData.fieldTypeString + "_" + fi }));
    };
    ApplicationRendererEntry.prototype.buildDateRange = function (field, fi) {
        var _this = this;
        return (React.createElement(FieldDateRange_1.FieldDateRange, { startDateTitle: csod.locales.get('Start Date', 'Start Date'), endDateTitle: csod.locales.get('End Date', 'End Date'), isRequired: field.fieldData.isRequired, value1: field.value1, value2: field.value2, idTag: field.fieldData.idTag, errorMessage: field.errorMessage ? this.requiredDateErrorMessage : '', startDateErrorMessage: field.startDateErrorMessage, endDateErrorMessage: field.endDateErrorMessage, onRef: fi === 0 ? function (r) { return _this.focusRef = r; } : function () { }, key: field.fieldData.fieldTypeString + "_" + fi, onChange: function (date, value, isValid, id) { _this._onChangeDateRange(date, value, isValid, id); }, shouldClearIfNotValid: true, displayFullDate: field.fieldData.displayFullDate }));
    };
    ApplicationRendererEntry.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", null, this.buildApplicationRendererFields()),
            React.createElement("div", null, this.props.addEntryText.length ? React.createElement(Hyperlink_1.Hyperlink, { role: 'button', text: this.props.addEntryText, type: "Action", onClick: function () { return _this._onAddEntry(_this.props.sectionId); } }) : null)));
    };
    ApplicationRendererEntry.defaultProps = {
        entries: [],
        deleteEntryText: "",
        addEntryText: "",
        hideDelete: true,
        sectionId: 0,
        minimumEntries: 0,
        key: "",
        onChange: function () { },
        onChangeNoId: function () { },
        onChangeDate: function () { },
        onChangeDaterange: function () { },
        onEntryDeleted: function () { },
        onAddEntry: function () { }
    };
    return ApplicationRendererEntry;
}(React.Component));
exports.ApplicationRendererEntry = ApplicationRendererEntry;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["ApplicationRendererEntry"] = ["CareerSite"];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationRendererEntry/ApplicationRendererEntry.js
// module id = 337
// module chunks = 0 1